import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  NoticeTopicSearchInput,
  NoticeTopicSearchQuery,
} from "../../../generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../utils";

const noticeTopicSearchQuery = graphql(`
  query noticeTopicSearch($noticeTopicSearchInput: NoticeTopicSearchInput!) {
    noticeTopicSearch(NoticeTopicSearchInput: $noticeTopicSearchInput) {
      results {
        redacted
        score
        guid
        procurementStage {
          id
          stage
        }
        signals {
          id
          name
          category
        }
        country
        stage
        stagev2
        name
        entityType
        currency
        value
        publishDate
        closeDate
        awardDate
        expiryDate
        url
        buyers {
          id
          guid
          name
          categoryAssignments {
            categoryId
            categoryName
            parentCategoryId
            parentCategoryName
            source
          }
        }
        isHidden
        suppliers {
          id
          name
          guid
          isSme
        }
        lists {
          id
          name
        }
        assignee {
          guid
          firstName
          lastName
        }
        comments {
          id
          author {
            guid
            firstName
          }
        }
        seenByUsers {
          firstName
          guid
        }
        relatedFrameworkProcess {
          frameworkId
          frameworkName
          processType
        }
        leads {
          id
          name
        }
        hasBuyerLeads
        bid {
          id
          name
        }
      }
      totalResults
    }
  }
`);

export function useNoticeTopicSearch(
  input: NoticeTopicSearchInput,
  options?: UseQueryOptions<NoticeTopicSearchQuery, unknown, NoticeTopicSearchQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery<
    NoticeTopicSearchQuery,
    { noticeTopicSearchInput: NoticeTopicSearchInput }
  >(["noticeTopicSearch", input], noticeTopicSearchQuery, [{ noticeTopicSearchInput: input }], {
    ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
    ...options,
  });

  return {
    data: data?.noticeTopicSearch,
    ...rest,
  };
}
